import { CanvasState } from '../../tabs/CampaignWorkflowTab/components/Canvas/state/CanvasState';
import { Canvas } from '../Canvas/Canvas';
import { NodeTypeKeys } from '../Canvas/utils/NodeTypeKeys';
import { IsInFlowService } from '../Workflow/types';

export class FlowService implements IsInFlowService {
  public constructor(private canvasState: CanvasState) {}

  public isAnyMessageInFlow(): boolean {
    const canvas = Canvas.createFromState(this.canvasState);

    return (
      canvas.hasNodeInFlow(NodeTypeKeys.sendEmailNodeType) ||
      canvas.hasNodeInFlow(NodeTypeKeys.displayWebContentNodeType)
    );
  }

  public isDisplayWebsiteContentInFlow(): boolean {
    const canvas = Canvas.createFromState(this.canvasState);

    return canvas.hasNodeInFlow(NodeTypeKeys.displayWebContentNodeType);
  }

  public isSendEmailInFlow(): boolean {
    const canvas = Canvas.createFromState(this.canvasState);

    return canvas.hasNodeInFlow(NodeTypeKeys.sendEmailNodeType);
  }

  public isBranchingEnabled(): boolean {
    const canvas = Canvas.createFromState(this.canvasState);

    return canvas.hasNodeInFlow(NodeTypeKeys.branchNameNodeType);
  }
}
